import {
  emailSchema,
  nameSchema,
  phoneSchema,
  messageSchema,
  stringSchema,
  optionalNameSchema,
  trueOnlySchema,
} from "@/schemas";
import { z } from "zod";

const fakeCaptchaSchema = z.boolean().refine((val) => val === true, {
  message: "You must agree to proceed",
});

export const formSupportSchema = z
  .object({
    firstName: nameSchema,
    lastName: nameSchema,
    email: emailSchema,
    phone: phoneSchema,
    businessName: optionalNameSchema,
    type: stringSchema,
    topic: stringSchema,
    message: messageSchema,
    agree: trueOnlySchema,
    //NOTE: ⚠️ temporary placeholder
    captcha: fakeCaptchaSchema,
  })
  .superRefine((data, ctx) => {
    if (
      data.type?.toLowerCase() === "business" &&
      (!data.businessName || data.businessName.trim() === "")
    ) {
      ctx.addIssue({
        path: ["businessName"],
        code: "custom",
        message: "Business name is required when type is Business",
      });
    }
  });
